module.exports = __webpack_public_path__ + "img/iconNo15.ed074507.png";